import { render, staticRenderFns } from "./UiDropdownMultiple.vue?vue&type=template&id=748c44d4&scoped=true"
import script from "./UiDropdownMultiple.vue?vue&type=script&lang=js"
export * from "./UiDropdownMultiple.vue?vue&type=script&lang=js"
import style0 from "./UiDropdownMultiple.vue?vue&type=style&index=0&id=748c44d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748c44d4",
  null
  
)

export default component.exports